import { render, staticRenderFns } from "./CuponsPage.vue?vue&type=template&id=06e75480&scoped=true&"
import script from "./CuponsPage.vue?vue&type=script&lang=js&"
export * from "./CuponsPage.vue?vue&type=script&lang=js&"
import style0 from "./CuponsPage.vue?vue&type=style&index=0&id=06e75480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e75480",
  null
  
)

export default component.exports